import React from 'react';
import style from "./index.module.css";
import {Breadcrumb, Divider} from "antd";
import CertificateNavModule from "../../components/certificateNavModule";
import {useLocation, useNavigate} from "react-router-dom";
import CertificationScope from "../../components/certificationScope";
import CertificationRules from "../../components/certificationRules";
import CertificationPublicFile from "../../components/certificationPublicFile";

const ThirdPage = () => {
    const locaton = useLocation();
    const navigate = useNavigate();
    let subPath = locaton?.state?.subPath;

    const baseItem = [
        {
            title: <div>首页</div>,
        },
        {
            title: "认证服务",
        },
    ];

    switch (subPath) {
        case "c1":
            baseItem.push({
                title: "认证业务范围",
            });
            break;
        case "c2":
            baseItem.push({
                title: "认证实施规则",
            });
            break;
        case "c3":
            baseItem.push({
                title: "公开文件",
            });
            break;
        default:
            // 如果需要处理其他情况，可以加上 default 分支
            break;
    }


    return (
        <div className={style.pageContainer}>
            <Breadcrumb
                items={baseItem}
            />

            <div className={style.content}>
                <div className={style.leftNavBar}>
                    <div className={subPath === "c1" ? style.leftNavBarBtnPushed : style.leftNavBarBtn} onClick={() => {
                        navigate("/certification", {state: {subPath: "c1"}})
                    }}>认证业务范围
                    </div>
                    <div className={subPath === "c2" ? style.leftNavBarBtnPushed : style.leftNavBarBtn} onClick={() => {
                        navigate("/certification", {state: {subPath: "c2"}})
                    }}>认证实施规则
                    </div>
                    <div className={subPath === "c3" ? style.leftNavBarBtnPushed : style.leftNavBarBtn} onClick={() => {
                        navigate("/certification", {state: {subPath: "c3"}})
                    }}>公开文件
                    </div>
                    <div style={{height:60}}/>
                    <CertificateNavModule/>
                </div>

                <div className={style.rightMainContainer}>
                    <div>
                        <div className={style.pageTitle}>认证服务</div>
                        <Divider style={{padding: '0 30px', borderColor: '#043554'}}>CERTIFICATE SERVICES</Divider>
                    </div>


                    <div className={style.articleContainer}>
                        {subPath === "c1" ? (<CertificationScope/>)
                            : subPath === "c2" ? (<CertificationRules/>)
                                : subPath === "c3" ? (<CertificationPublicFile/>)
                                : (<div/>)}
                    </div>

                </div>
            </div>

        </div>
    );
};

export default ThirdPage;